import { render, staticRenderFns } from "./holdBankList.vue?vue&type=template&id=de41d6e4&"
import script from "./holdBankList.vue?vue&type=script&lang=js&"
export * from "./holdBankList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports